import { useState, useEffect } from "react";
import { Cookie, Shield } from "lucide-react";
import { Button } from "@/components/ui/button";

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // SSR guard - skip in server-side rendering context
    if (typeof window === 'undefined') return;
    
    // Prüfe ob bereits eine Ablehnung vorliegt
    const cookieConsent = localStorage.getItem("cookieConsent");
    
    if (cookieConsent === "rejected") {
      // User hat abgelehnt - GA deaktivieren
      if (typeof window !== 'undefined' && typeof (window as any).gtag === 'function') {
        (window as any).gtag('consent', 'update', {
          'analytics_storage': 'denied',
          'ad_storage': 'denied'
        });
      }
    } else if (cookieConsent !== "accepted") {
      setShowBanner(true);
    }
    // Wenn "accepted" oder nichts gesetzt: Analytics läuft bereits (default granted)
  }, []);

  const handleAccept = () => {
    if (typeof window !== 'undefined') {
      localStorage.setItem("cookieConsent", "accepted");
    }
    // Analytics läuft bereits, keine Änderung nötig
    setShowBanner(false);
  };

  const handleReject = () => {
    if (typeof window !== 'undefined') {
      localStorage.setItem("cookieConsent", "rejected");
      
      // Google Analytics deaktivieren
      if (typeof (window as any).gtag === 'function') {
        (window as any).gtag('consent', 'update', {
          'analytics_storage': 'denied',
          'ad_storage': 'denied'
        });
      }
    }
    
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 pointer-events-none">
      <div className="w-full pointer-events-auto animate-fade-in">
        <div className="bg-card/95 backdrop-blur-md border-t border-border shadow-lg">
          <div className="container mx-auto px-4 py-4 sm:py-6">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6">
              {/* Icon & Text */}
              <div className="flex items-start gap-3 flex-1">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-accent/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Cookie className="w-5 h-5 sm:w-6 sm:h-6 text-accent" />
                </div>
                <div className="flex-1">
                  <p className="text-sm sm:text-base font-semibold text-foreground mb-1">
                    Cookie-Einstellungen
                  </p>
                  <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed">
                    Wir verwenden Cookies, um Ihnen ein optimales Nutzererlebnis zu bieten und unsere Website zu verbessern. 
                    Weitere Informationen finden Sie in unserer{" "}
                    <a 
                      href="/datenschutz" 
                      className="text-accent hover:text-accent/80 underline transition-colors"
                    >
                      Datenschutzerklärung
                    </a>.
                  </p>
                </div>
              </div>

              {/* Buttons */}
              <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
                <Button
                  onClick={handleReject}
                  variant="outline"
                  className="w-full sm:w-auto min-w-[140px]"
                >
                  Ablehnen
                </Button>
                <Button
                  onClick={handleAccept}
                  className="w-full sm:w-auto min-w-[140px] bg-primary text-primary-foreground hover:bg-primary/90 shadow-md hover:shadow-lg transition-all"
                >
                  Akzeptieren
                </Button>
              </div>
            </div>

            {/* Privacy Shield Icon */}
            <div className="mt-3 pt-3 border-t border-border/50">
              <p className="text-xs text-muted-foreground flex items-center justify-center gap-1.5">
                <Shield className="w-3.5 h-3.5" />
                Ihre Privatsphäre ist uns wichtig
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
